import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEuroComponent } from "./med-icon-euro.component";

@NgModule({
  declarations: [
    MedIconEuroComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEuroComponent,
  ],
})
export class MedIconEuroModule { }
